var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18px","height":"18px","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"m19.5 4.5l-15 15m0 0h11.25m-11.25 0V8.25"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }